import { FolderArrowDownIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "react-tooltip";
import { twMerge } from "tailwind-merge";

import { AI_BACKEND_URL_DOWNLOAD_HARMONY_MAKER_FILES } from "@/constants/constants";
import { DOWNLOAD_AUDIO_TYPES } from "@/constants/posthog/downloadAudio";
import { trackAudioDownload } from "@/data/posthog/trackAudioDownload";
import {
  StemSplitGroupWithAudioNoDates,
  StemSplitWithAudioNoDates,
} from "@/types/defs/stemSplit";
import { getFileExtension } from "@/utils/filenameExtension/getFileExtension";

export function DownloadStemSplitGroup({
  stemSplitGroup,
  className,
}: {
  stemSplitGroup: StemSplitGroupWithAudioNoDates;
  className?: string;
}) {
  if (stemSplitGroup.stemSplits.length === 0) {
    return null;
  }

  const baseName = stemSplitGroup.name;
  const zipFileName = `${baseName}_${stemSplitGroup.stemSplitType}`;
  const usedFilenames = new Set<string>();

  const downloadInstructions = stemSplitGroup.stemSplits.map(
    (stemSplit: StemSplitWithAudioNoDates) => {
      const originalExtension = getFileExtension(
        stemSplit.outputSound.filename
      );

      const stemFileName = `${baseName}_${stemSplit.stemType}.${originalExtension}`;

      let filenameInZip = stemFileName;
      let counter = 1;

      // Handle duplicate filenames
      while (usedFilenames.has(filenameInZip)) {
        const nameWithoutExt = stemFileName.replace(/\.[^/.]+$/, "");
        filenameInZip = `${nameWithoutExt}_${counter}.${originalExtension}`;
        counter++;
      }

      usedFilenames.add(filenameInZip);

      return {
        soundFileUrl: stemSplit.outputSound.presignedUrlDownload,
        filenameInZip: filenameInZip,
        lengthS: stemSplitGroup.lengthS,
        pan: 0,
        timeShift: 0,
        ownerId: stemSplitGroup.ownerId,
      };
    }
  );

  const trackDownload = () => {
    trackAudioDownload({
      audioType: DOWNLOAD_AUDIO_TYPES.STEM_SPLITTER,
      entityId: stemSplitGroup.id,
    });
  };

  return (
    <form
      className={twMerge("h-6 w-6", className)}
      action={AI_BACKEND_URL_DOWNLOAD_HARMONY_MAKER_FILES}
      method="POST"
    >
      <input
        type="hidden"
        name="data"
        value={JSON.stringify({
          downloadInstructions,
          conversionGroupfilenameWithoutExtension: zipFileName,
          doProcessing: false,
        })}
      />
      <button type="submit" className="h-6 w-6" onClick={trackDownload}>
        <FolderArrowDownIcon
          data-tooltip-id={`download-stem-split-group-tooltip-${stemSplitGroup.id}`}
          data-tooltip-content="Download"
          data-tooltip-place="top"
          className="h-6 w-6 stroke-gray-900"
        />
        <Tooltip
          id={`download-stem-split-group-tooltip-${stemSplitGroup.id}`}
        />
      </button>
    </form>
  );
}
